import {
	AZURE_SPEECH_FAMILY,
	SPEECH_LOCALE_PATTERN,
} from '@UI/Pages/Administration/AiEngines/azureSpeechValues';

/** The minimal shape this constraint reads. */
type SpeechShape = {
	readonly family: string | null;
	readonly hasAzureSpeechSettings: boolean;
};

/** Active only when the Azure Speech settings section is shown. */
function isSpeechLocaleValid<T extends SpeechShape>(value: string, formData: T): boolean {
	if (formData.family !== AZURE_SPEECH_FAMILY || !formData.hasAzureSpeechSettings) {
		return true;
	}

	return SPEECH_LOCALE_PATTERN.test(value.trim());
}

export default isSpeechLocaleValid;
